import React, { FC } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { NavigationBar } from '../../components/NavigationBar';
import { styled } from '@mui/system';
import { VENUE_NAV_BAR_QUERY } from './graphql';
import { useQuery } from '@apollo/client';
import { Typography, Stack, Link, Box } from '@mui/material';
import { PVBlack } from '@pv/common/colors';

export const PageContainer = styled(Box)`
  max-width: 1200px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  position: relative;
  min-height: calc(100vh - 80px);
  margin-top: 0;

  @media (min-width: 600px) {
    padding: 24px;
  }
`;

export const InquiryLayout: FC = () => {
  const params = useParams();
  const { venueSlug } = params;
  const { data } = useQuery(VENUE_NAV_BAR_QUERY, {
    variables: { venueSlug },
    skip: !venueSlug,
  });

  const navBarVenueLocationString = [
    data?.marketplaceVenue?.address?.city,
    data?.marketplaceVenue?.address?.state,
  ].join(', ');

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1100,
          backgroundColor: '#fff',
          borderBottom: '1px solid #e0e0e0',
        }}
      >
        <NavigationBar>
          <Stack
            direction="row"
            alignItems="baseline"
            display={{ xs: 'none', sm: 'flex' }}
            gap="8px"
          >
            <Link
              variant="h6"
              sx={{
                fontWeight: '700',
                fontSize: '18px',
                color: PVBlack,
              }}
              underline="hover"
              href={`/venues/${venueSlug}`}
            >
              {data?.marketplaceVenue?.name}
            </Link>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: '400',
                fontSize: '16px',
              }}
            >
              {navBarVenueLocationString}
            </Typography>
          </Stack>
        </NavigationBar>
      </div>
      <PageContainer>
        <Outlet />
      </PageContainer>
    </div>
  );
};
